import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import EditPeriodPage from "./EditPeriodPage";
import PeriodListingPage from "./PeriodListingPage";
import {
  withPermission,
  Roles,
} from "../../../util/PermissionProvider";

export default function PeriodManagementPage(props) {
  const { match } = props;
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}`}
        component={withPermission(
          PeriodListingPage,
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR, Roles.CINEFAN_VIEWER],
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/edit/:id`}
        component={withPermission(
          EditPeriodPage,
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR, Roles.CINEFAN_VIEWER],
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR]
        )}
      />
      <Route render={() => <Redirect to={`${match.url}`} />} />
    </Switch>
  );
}
